import { _ } from "js/vendor";
import { getStaticUrl } from "js/config";
import React from "react";

export function StaticImage(props) {
    let imgProps = _.omit(props, ["src", "width", "height", "size", "background", "round"]);

    let style = {
        width: props.size ?? props.width ?? "100%",
        height: props.size ?? props.height ?? "100%",
        objectFit: "contain",
        verticalAlign: "middle",
        background: props.background,
        borderRadius: props.round && "50%",
    };

    return <img src={getStaticUrl(props.src)} style={style} {...imgProps}/>;
}
